import { createContext, Dispatch, Reducer } from 'react';
import { AccountInfo } from '@azure/msal-browser';

// Manage state that's used to make capability determinations
export interface CapabilityReducerState {
    agpUser?: AccountInfo;
    nonAdminMode?: boolean;
}

export enum CapabilityActionType {
    setAgpUser = 'setAgpUser',
    toggleNonAdminMode = 'toggleNonAdminMode',
}

export interface CapabilityReducerAction {
    type: CapabilityActionType;
    user?: AccountInfo;
}

// Use a reducer to organize state change updates. The dispatch can be provided in the CapabilityDispatch
// context to allow any component to update capability state.
export const capabilityReducer: Reducer<
    CapabilityReducerState,
    CapabilityReducerAction
> = (
    state: CapabilityReducerState,
    action: CapabilityReducerAction
): CapabilityReducerState => {
    switch (action.type) {
        case CapabilityActionType.setAgpUser:
            return {
                ...state,
                agpUser: action.user,
            };
        case CapabilityActionType.toggleNonAdminMode: {
            const newValue = !state.nonAdminMode;
            localStorage.setItem('nonAdminMode', JSON.stringify(newValue));
            return {
                ...state,
                nonAdminMode: newValue,
            };
        }
        default:
            return state;
    }
};

export const CapabilityDispatch = createContext<
    Dispatch<CapabilityReducerAction>
>(() => {});
